export const ENDPOINT_CURRENT_USER = "/user";
export const ENDPOINT_LOGIN = "/login";
export const ENDPOINT_REGISTER = "/register";

export const ENDPOINT_CREATE_POST = "/posts";
export const ENDPOINT_POSTS = id => `/posts/${id}`;

export const ENDPOINT_MESSAGES = (id, first, after) =>
  `/messages/${id}?first=${first}&after=${after}`;
export const ENDPOINT_CREATE_MESSAGE = "/messages";

export const ENDPOINT_SEARCH_POSTS = (title, categories) => {
  let string = "";
  categories.forEach(category => {
    string = string + `&categories=${category}`;
  });
  return `/posts?title=${title}` + string;
};

export const ENDPOINT_UPDATE_USER = id => `/user/${id}`;
export const ENDPOINT_NOTIFICATIONS = id => `/notifications/${id}`;

export const ENDPOINT_CREATE_NOTIFICATION = "/notifications";

export const ENDPOINT_DELETE_NOTIFICATIONS = ({ user, post }) => {
  return `/notifications/${user}/${post}`;
};

export const ENDPOINT = "https://api-rest-socket-tesis.herokuapp.com";
//export const ENDPOINT = "http://localhost:4001";
